var React = require('react');

function EmailFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.273 5.819h.003c.11 0 .218-.032.305-.089l.024-.015.016-.01.276-.229L14.494.032A.077.077 0 0014.432 0H.077a.076.076 0 00-.048.017l6.903 5.688c.087.072.21.114.341.114zM0 .771v8.07l4.945-3.995L0 .771zm9.57 4.103l4.938 3.969V.797L9.57 4.874zM8 6.169c-.197.162-.455.251-.726.251s-.528-.088-.724-.249l-1.133-.934L0 9.612v.014c0 .042.035.077.078.077h14.355c.04 0 .076-.035.076-.077v-.013L9.096 5.265 8 6.169z"}));
}

EmailFooter.defaultProps = {"width":"14.509","height":"9.703","viewBox":"0 0 14.509 9.703"};

module.exports = EmailFooter;

EmailFooter.default = EmailFooter;
